module.exports = __webpack_public_path__ + "img/download2.d97fab24.jpg";